import { render, staticRenderFns } from "./serarchFore.vue?vue&type=template&id=18ba5534&scoped=true&"
import script from "./serarchFore.vue?vue&type=script&lang=js&"
export * from "./serarchFore.vue?vue&type=script&lang=js&"
import style0 from "./serarchFore.vue?vue&type=style&index=0&id=18ba5534&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ba5534",
  null
  
)

export default component.exports